import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useCallback, useContext, useEffect, useState } from 'react';
import Spinner from '@/components/Spinner';
import { REDIRECT_URI_KEY } from '@/constants/common';
import { AuthContext } from '@/context/AuthProvider';
import { CartContext } from '@/context/CartProvider';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { AvailableCoupon, Coupon as OrginalCoupon } from '@/models/Coupon';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import fetchAllCoupons from '@/utils/api/fetchAllCoupons';
import ApplyCoupon from './ApplyCoupon';
const CouponModal = dynamic(() => import('./CouponModal'), {
  ssr: false,
  loading: () => <Spinner />
});
interface Props {
  availableCoupons: AvailableCoupon[];
  appliedCoupon: AvailableCoupon | null;
  onChange: (coupon: AvailableCoupon | null) => void;
  handleCouponRemoval: VoidFunction;
  buyerPhoneNumber?: string;
}
const Coupon = ({
  appliedCoupon,
  availableCoupons,
  onChange,
  handleCouponRemoval,
  buyerPhoneNumber
}: Props) => {
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [allCoupons, setAllCoupons] = useState<OrginalCoupon[]>([]);
  const {
    push
  } = useRouter();
  const {
    isAuthenticated
  } = useContext(AuthContext);
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const {
    currentVendor
  } = useContext(CartContext);
  const currentVendorId = currentVendor?.id.toString();
  const applyCouponHandler = () => {
    if (isAuthenticated) {
      const eventParams = {
        VendorName: currentVendor?.company_name,
        VendorId: currentVendorId
      };
      trackCustomEvent(CustomEventTypes.USER_CLICKED_ON_VIEW_MORE_COUPON, JSON.stringify(eventParams));
      setShowCouponModal(true);
    } else {
      push(`/login?${REDIRECT_URI_KEY}=/cart`);
    }
  };
  const getCouponsList = useCallback(async () => {
    const couponsList = await fetchAllCoupons(buyerPhoneNumber);
    setAllCoupons(couponsList);
  }, [buyerPhoneNumber]);
  useEffect(() => {
    if (isAuthenticated) {
      getCouponsList();
    }
  }, [isAuthenticated, getCouponsList]);
  return <>
      <ApplyCoupon onClick={applyCouponHandler} appliedCoupon={appliedCoupon} hanldeCouponRemoval={handleCouponRemoval} data-sentry-element="ApplyCoupon" data-sentry-source-file="index.tsx" />
      {showCouponModal ? <CouponModal allCoupons={allCoupons} availableCoupons={availableCoupons} appliedCoupon={appliedCoupon} toggleHandler={() => setShowCouponModal(false)} onApply={(appliedCoupon: AvailableCoupon) => {
      const eventParams = {
        VendorName: currentVendor?.company_name,
        VendorId: currentVendorId,
        CouponCode: appliedCoupon?.couponCode,
        IsUserInput: appliedCoupon?.IsUserInput ? 'Yes' : 'No'
      };
      trackCustomEvent(CustomEventTypes.USER_APPLIED_COUPON, JSON.stringify(eventParams));
      onChange(appliedCoupon);
      setShowCouponModal(false);
    }} /> : null}
    </>;
};
export default Coupon;